import * as colors from 'app/styles/colors';
import * as layout from 'app/styles/layout';
import * as fonts from 'app/styles/fonts';
import * as screens from 'app/styles/screens';
export * from './theme';

let GlobalStyle; // eslint-disable-line
if (process.env.WEB === 'true') {
  GlobalStyle = require('app/styles/baseStyles').GlobalStyle;
}

export const isNative = process.env.WEB !== 'true';

export { colors, layout, fonts, GlobalStyle, screens };
